const liczbaDrzwi = {
    t: 'Liczba drzwi',
    type: 'range',
    name: 'liczba-drzwi',
    hint: { url: '/doors' },
}

export default liczbaDrzwi